import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type Props = {
  icon?: string; //e.g. `fa-light fa-folder` or `mdi-folder`
};


export default /*#__PURE__*/_defineComponent({
  __name: 'IconPreview',
  props: {
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string; //e.g. `fa-light fa-folder` or `mdi-folder`
}



const isMdi = computed(() => props.icon?.startsWith('mdi') ?? false);

const isFaIcon = computed(() => props.icon?.startsWith('fa-') ?? false);

const faIcon = computed(() => props.icon?.replace('fa-', '').split(' ') ?? []);

return { __sfc: true,props, isMdi, isFaIcon, faIcon }
}

})